import * as Yup from 'yup'

export const getValidationSchema = () =>
  Yup.object().shape({
    supportType: Yup.array().of(
      Yup.object().shape({
        id: Yup.number(),
        name: Yup.string(),
        conform: Yup.number().min(0),
        defect: Yup.number().min(0),
        reason: Yup.string().nullable(),
        received: Yup.number().nullable(),
        imageUploaded: Yup.boolean().default(false)
      })
    )
  })

export const getInitialValues = (supportType, offlineData) => {
  const supportTypeResult = supportType.map((support, index) => {
    if (offlineData?.data) {
      const offlineSupportReceived = offlineData.data[`supportType[${index}].received`]
      const offlineSupportImageUploaded = offlineData.data[`supportType[${index}].imageUploaded`]
      if (offlineSupportReceived) {
        return {
          ...support,
          ...{
            received: offlineSupportReceived,
            imageUploaded: offlineSupportImageUploaded || false
          }
        }
      }
      return support
    }
    return support
  })
  return { supportType: supportTypeResult }
}
